'use client';

import { PENDING_SAVE_RECIPE_KEY } from '@fdc/constants/recipe.constants';
import { useAuth } from '@fdc/hooks/useAuth';
import { useEffect } from 'react';

import { useRemoveFavouriteRecipe } from './useRemoveFavouriteRecipe';
import { useSaveFavouriteRecipe } from './useSaveFavouriteRecipe';

export const useFavouriteRecipeHandlers = ({ autoPendingSave = true } = {}) => {
  const { isAuthenticated } = useAuth();
  const { handleSaveFavouriteRecipe } = useSaveFavouriteRecipe();
  const { handleRemoveFavouriteRecipe } = useRemoveFavouriteRecipe();

  useEffect(() => {
    if (!autoPendingSave) {
      return;
    }
    const recipeId = sessionStorage.getItem(PENDING_SAVE_RECIPE_KEY);
    if (isAuthenticated && recipeId) {
      sessionStorage.removeItem(PENDING_SAVE_RECIPE_KEY);
      handleSaveFavouriteRecipe(recipeId);
    }
  }, [autoPendingSave, isAuthenticated, handleSaveFavouriteRecipe]);

  const saveRecipe = async (recipeId: string) => {
    try {
      const res = await handleSaveFavouriteRecipe(recipeId);
      if (!res) {
        return false;
      }
      return (
        !res?.data?.saveFavouriteRecipe?.errors?.length &&
        res?.data?.saveFavouriteRecipe?.favouriteRecipe?.recipeId === recipeId
      );
    } catch {
      return false;
    }
  };

  const removeRecipe = async (recipeId: string) => {
    try {
      const res = await handleRemoveFavouriteRecipe(recipeId);
      if (!res) {
        return false;
      }
      return (
        !res.data?.removeFavouriteRecipe?.errors?.length &&
        res.data?.removeFavouriteRecipe?.recipeId === recipeId
      );
    } catch {
      return false;
    }
  };

  return { saveRecipe, removeRecipe };
};
